import { Box } from "@mui/material";
import { useRef, useState } from "react";
import { GoCheckCircleFill } from "react-icons/go";
import { MdFileUploadOff } from "react-icons/md";

const Download = ({ formData, handleChange, value, errors }) => {
  const [fileTypeError, setFileTypeError] = useState("");
  const fileInputRef = useRef(null);
  const uploadedFile = formData?.document?.[value]?.value;
  const isValidUploadedValue = (fileValue) => {
    if (!fileValue) return false;
    if (typeof File !== "undefined" && fileValue instanceof File) return true;
    if (typeof Blob !== "undefined" && fileValue instanceof Blob) return true;
    if (typeof fileValue === "object" && typeof fileValue.name === "string" && fileValue.name !== "") return true;
    return false;
  };
  const hasUploadedFile = isValidUploadedValue(uploadedFile);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileUpload = async (e) => {
    const selectedFile = e.target.files?.[0];

    if (!selectedFile) {
      console.log("No file is selected");
      return;
    }

    const isPdfFile =
      selectedFile.type === "application/pdf" ||
      selectedFile.name.toLowerCase().endsWith(".pdf");

    if (!isPdfFile) {
      setFileTypeError("Only PDF files are allowed.");
      e.target.value = "";
      return;
    }

    const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
    if (selectedFile.size > maxSizeInBytes) {
      setFileTypeError("File size must be less than 2MB.");
      e.target.value = "";
      return;
    }

    setFileTypeError("");

    const updatedFormData = {
      target: {
        value: selectedFile
      }
    };
    handleChange(updatedFormData, "document", value);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.4rem"
      }}
    >
      <Box
        sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem"
      }}
    >
      <div
        className={`${
          !hasUploadedFile && "bg-slate-200"
        } rounded-lg flex items-center justify-center w-[80px] h-[66px]`}
      >
        {!hasUploadedFile ? (
          <MdFileUploadOff className="text-[50px] text-slate-500" />
        ) : (
          <GoCheckCircleFill className="text-[50px] text-[#17bebb]" />
        )}
      </div>
      <input
        type="file"
        accept="application/pdf,.pdf"
        ref={fileInputRef}
        onChange={handleFileUpload}
        style={{ display: "none" }}
      />
      <button
        type="button"
        onClick={handleButtonClick}
        className={`${
          !hasUploadedFile
            ? "bg-[#b60041] hover:bg-blue-500"
            : "bg-slate-500 hover:bg-slate-600"
        }  h-full px-4 lg:py-4 py-2 text-white font-bold rounded-lg `}
      >
        {hasUploadedFile ? "Replace Document" : "Upload Document"}
      </button>
      </Box>
      {fileTypeError && (
        <p className="text-[12px] font-semibold text-[#c62828] text-center">
          {fileTypeError}
        </p>
      )}
    </Box>
  );
};

export default Download;
